import { BlogSection } from '@/types/blog';

export const vier_gs: BlogSection = {
  id: 'vier-gs',
  title: 'Kostolanys Erfolgsformel: Die 4 Gs für jeden Anleger',
  content: `
    <p>Das Herzstück von Kostolanys <strong>Anlagestrategie</strong> ist seine berühmte Formel der „<strong>4 Gs</strong>": Geld, Gedanken, Geduld und Glück. Jedes dieser Elemente ist entscheidend für den langfristigen Erfolg und untrennbar miteinander verbunden.</p>

    <div class="grid md:grid-cols-2 gap-6 my-10">
      <div class="bg-gradient-to-br from-green-50 to-green-100 border border-green-200 p-6 rounded-xl">
        <div class="flex items-center mb-4">
          <div class="w-10 h-10 bg-green-500 text-white rounded-full flex items-center justify-center font-bold text-lg mr-3">1</div>
          <h4 class="text-xl font-bold text-green-800">Geld</h4>
        </div>
        <p class="text-green-700 mb-3"><strong>Nur mit freiem Kapital investieren</strong></p>
        <p class="text-green-600 text-sm">Kostolany warnte eindringlich davor, mit geliehenem Geld oder auf Kredit zu spekulieren. Nur wer frei von Schuldendruck ist, hat die emotionale Freiheit, seine Strategie in Krisen durchzuhalten.</p>
        <div class="mt-3 p-3 bg-white/50 rounded text-xs text-green-700">
          <strong>Moderne Umsetzung:</strong> ETF-Sparpläne mit langfristig freiem Kapital
        </div>
      </div>

      <div class="bg-gradient-to-br from-blue-50 to-blue-100 border border-blue-200 p-6 rounded-xl">
        <div class="flex items-center mb-4">
          <div class="w-10 h-10 bg-blue-500 text-white rounded-full flex items-center justify-center font-bold text-lg mr-3">2</div>
          <h4 class="text-xl font-bold text-blue-800">Gedanken</h4>
        </div>
        <p class="text-blue-700 mb-3"><strong>Eigene Meinung entwickeln</strong></p>
        <p class="text-blue-600 text-sm">Folgen Sie nicht blind den Ratschlägen von „Börsengurus" oder Massengerüchten. Entwickeln Sie eine fundierte, eigene Meinung über die Marktentwicklung.</p>
        <div class="mt-3 p-3 bg-white/50 rounded text-xs text-blue-700">
          <strong>Moderne Umsetzung:</strong> Kontinuierliche Finanzbildung und kritische Quellenprüfung
        </div>
      </div>

      <div class="bg-gradient-to-br from-amber-50 to-amber-100 border border-amber-200 p-6 rounded-xl">
        <div class="flex items-center mb-4">
          <div class="w-10 h-10 bg-amber-500 text-white rounded-full flex items-center justify-center font-bold text-lg mr-3">3</div>
          <h4 class="text-xl font-bold text-amber-800">Geduld</h4>
        </div>
        <p class="text-amber-700 mb-3"><strong>Das entscheidende Element</strong></p>
        <p class="text-amber-600 text-sm">„Der Aktienmarkt ist ein Ort, an dem Geld von den Ungeduldigen zu den Geduldigen transferiert wird." Geduld ist der Schlüssel, um langfristig zu denken und kurzfristige Schwankungen zu ignorieren.</p>
        <div class="mt-3 p-3 bg-white/50 rounded text-xs text-amber-700">
          <strong>Moderne Umsetzung:</strong> Buy-and-Hold-Strategie auch in volatilen Marktphasen
        </div>
      </div>

      <div class="bg-gradient-to-br from-purple-50 to-purple-100 border border-purple-200 p-6 rounded-xl">
        <div class="flex items-center mb-4">
          <div class="w-10 h-10 bg-purple-500 text-white rounded-full flex items-center justify-center font-bold text-lg mr-3">4</div>
          <h4 class="text-xl font-bold text-purple-800">Glück</h4>
        </div>
        <p class="text-purple-700 mb-3"><strong>Belohnung für Disziplin</strong></p>
        <p class="text-purple-600 text-sm">Glück ist keine zufällige Fügung, sondern stellt sich ein, wenn die ersten drei Gs konsequent befolgt werden. Es ist die Belohnung für harte Arbeit, Nachdenken und eiserne Geduld.</p>
        <div class="mt-3 p-3 bg-white/50 rounded text-xs text-purple-700">
          <strong>Moderne Umsetzung:</strong> Vertrauen in langfristig positive Marktentwicklung
        </div>
      </div>
    </div>

    <div class="bg-joerg-50 border-l-4 border-primary p-6 rounded-r-lg my-8">
      <h4 class="font-semibold text-joerg-800 mb-3">💡 Kostolanys Weisheit in der Praxis</h4>
      <blockquote class="text-joerg-700 italic">
        "Wer viel Geld hat, kann spekulieren, wer wenig Geld hat, darf nicht spekulieren, wer kein Geld hat, muss spekulieren."
      </blockquote>
      <p class="text-sm text-joerg-600 mt-3">Diese scheinbar paradoxe Aussage zeigt Kostolanys feinen Humor und seine tiefe Kenntnis der menschlichen Natur – sie ist jedoch eher als ironische Beobachtung zu verstehen denn als Anlageempfehlung.</p>
    </div>
  `
};